export const portalTarget: { current: null | HTMLDivElement } = {
  current: null,
};

export const ModalPortal = () => {
  return <div ref={(element) => (portalTarget.current = element)} />;
};
